<template>
  <div v-if="!!model">
    <h5>Dodaj podpisnika:</h5>
    <div class="input-group input-group-sm mb-3">
      <span class="input-group-text">Ime in priimek</span>
      <input type="text" class="form-control" v-model="model.name" />
    </div>
    <div class="input-group input-group-sm mb-3">
      <span class="input-group-text">Email</span>
      <input type="email" class="form-control" v-model="model.email" />
    </div>
    <div class="input-group input-group-sm mb-3">
      <span class="input-group-text">Fax</span>
      <input type="tel" class="form-control" v-model="model.fax" />
    </div>
    <div class="input-group input-group-sm mb-3">
      <span class="input-group-text">Telefon</span>
      <input type="tel" class="form-control" v-model="model.phone" />
    </div>
    <div class="mb-3">
      <button
        class="btn btn-primary btn-sm"
        @click="saveModel"
        :disabled="!(model.name?.length > 3 && model.email?.length > 6 && model.email.includes('@'))"
      >
        Dodaj podpisnika
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, toRef, toRefs, computed, defineComponent, watch, reactive, onMounted, inject } from "vue"

defineOptions({ name: "FacilityContactEdit" })

const props = defineProps({
  modelValue: { type: Object, default: () => ({}) },
})

const emit = defineEmits(["update:modelValue", "save"])

const model = ref({ ...props.modelValue })

// a v-on value is parsed as statements only while it contains a `;`, otherwise as a single
// expression - so multi-statement handlers live here, where formatting cannot invalidate them
const saveModel = () => {
  emit("update:modelValue", model.value)
  emit("save")
}
</script>
